"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var player_jsnlog_1 = require("player-jsnlog");
var Utilities_1 = require("../Utilities");
var Logger = (function () {
    function Logger() {
    }
    Logger.prototype.initialize = function (identifier, loggerAPIUrl, correlationID, context) {
        var _this = this;
        this._when = new Array();
        this._once = new Array();
        var defaultErrorLogger = player_jsnlog_1.JL('onerrorLogger');
        context = context || {
            level: "error",
            batchsize: "1",
            service: {
                contentsize: (1024 * 1024).toString(),
                responsetime: "2000"
            },
            page: {
                loadtime: "5000"
            }
        };
        csod.context.log = context;
        defaultErrorLogger.fatalException = function (logObject, e) {
            _this.fatal({
                data: logObject,
                error: e
            });
            return defaultErrorLogger;
        };
        if (context.level !== 'off') {
            this._setupLogger(identifier, loggerAPIUrl, correlationID, context);
        }
    };
    Logger.prototype.when = function (check, handler) {
        var subscriber = new Subscriber(check, handler);
        this._when.push(subscriber);
    };
    Logger.prototype.once = function (check, handler) {
        var subscriber = new Subscriber(check, handler);
        this._once.push(subscriber);
    };
    Logger.prototype.debug = function (value) {
        this._debug(value);
        this._notify(value);
    };
    Logger.prototype.info = function (value) {
        this._info(value);
        this._notify(value);
    };
    Logger.prototype.warn = function (value) {
        this._warn(value);
        this._notify(value);
    };
    Logger.prototype.error = function (value) {
        this._error(value);
        this._notify(value);
    };
    Logger.prototype.fatal = function (value) {
        this._fatal(value);
        this._notify(value);
    };
    Logger.prototype._setupLogger = function (identifier, loggerAPIUrl, correlationID, context) {
        var level;
        var contextLogLevel = typeof context === 'string' ? context : context.level;
        if (!window.performance)
            this._now = function () { return (new Date()).getTime(); };
        switch (contextLogLevel.toLocaleLowerCase()) {
            case "trace":
                level = player_jsnlog_1.JL.getTraceLevel();
                break;
            case "debug":
                level = player_jsnlog_1.JL.getDebugLevel();
                break;
            case "info":
                level = player_jsnlog_1.JL.getInfoLevel();
                break;
            case "warn":
                level = player_jsnlog_1.JL.getWarnLevel();
                break;
            case "error":
                level = player_jsnlog_1.JL.getErrorLevel();
                break;
            case "fatal":
                level = player_jsnlog_1.JL.getFatalLevel();
                break;
            default:
                level = player_jsnlog_1.JL.getOffLevel();
                break;
        }
        var logger = player_jsnlog_1.JL(identifier);
        var ajaxAppender = player_jsnlog_1.JL.createAjaxAppender('ajaxAppender');
        var consoleAppender = player_jsnlog_1.JL.createConsoleAppender('consoleAppender');
        this._flush = function () { ajaxAppender.sendBatch(); };
        var $this = this;
        window.addEventListener('beforeunload', function () {
            $this._flush();
        });
        ajaxAppender.setOptions({
            batchSize: parseInt(context.batchsize),
            url: loggerAPIUrl,
            level: level,
            beforeSend: function (xhr, json) {
                if (csod.context.env !== 'development') {
                    xhr.setRequestHeader('Authorization', 'Bearer ' + csod.context.token);
                }
                for (var i = 0; i < json.lg.length; i++) {
                    var level_1 = json.lg[i].l;
                    if (level_1 <= 2000) {
                        json.lg[i].l = 'Debug';
                    }
                    else if (level_1 > 2001 && level_1 <= 3000) {
                        json.lg[i].l = 'Info';
                    }
                    else if (level_1 > 3001 && level_1 <= 4000) {
                        json.lg[i].l = 'Warn';
                    }
                    else if (level_1 > 4001 && level_1 <= 5000) {
                        json.lg[i].l = 'Error';
                    }
                    else if (level_1 > 5001 && level_1 <= 6000) {
                        json.lg[i].l = 'Fatal';
                    }
                    else {
                        json.lg[i].l = 'Unknown';
                    }
                    if (Utilities_1.getType(json.lg[i].m) !== 'object') {
                        if (json.lg[i].m.indexOf('{') >= 0) {
                            json.lg[i].m = JSON.parse(json.lg[i].m);
                            json.lg[i].m.pageContextID = correlationID;
                        }
                        else {
                            console.log('Logging value must be a json object!');
                            return;
                        }
                    }
                    json.lg[i].t = new Date().toISOString();
                }
                json.m = json.lg;
                delete json.lg;
                delete json.r;
            }
        });
        logger.setOptions({
            "appenders": [ajaxAppender, consoleAppender],
            "level": level
        });
        this._debug = function (value) {
            logger.debug(value);
        };
        this._info = function (value) {
            logger.info(value);
        };
        this._warn = function (value) {
            logger.warn(value);
        };
        this._error = function (value) {
            logger.error(value);
            this._flush();
        };
        this._fatal = function (value) {
            logger.error(value);
            this._flush();
        };
        if (context.service) {
            var serviceReponseTimeThreshold = parseInt(context.service.responsetime);
            var serviceResponseSizeThreshold = parseInt(context.service.contentsize);
            $this.when(function (start) {
                return start instanceof XHRTraceMessage && start.state == XHRTraceMessageState.Begin;
            }, function (start) {
                var startTime = $this._now();
                $this.once(function (end) {
                    return start == end && start.state == XHRTraceMessageState.End;
                }, function (end) {
                    var endTime = $this._now();
                    var message = {
                        start: startTime,
                        end: endTime,
                        data: end.data,
                    };
                    if ((endTime - startTime) > serviceReponseTimeThreshold) {
                        message.warning = "Round trip took more than " + serviceReponseTimeThreshold + " ms";
                        $this.warn(message);
                    }
                    else if (end.data.size > serviceResponseSizeThreshold) {
                        message.warning = "Response size was greater than " + serviceResponseSizeThreshold + " bytes";
                        $this.warn(message);
                    }
                    else
                        $this.info(message);
                });
            });
        }
    };
    Logger.prototype._now = function () {
        return performance.now();
    };
    Logger.prototype._debug = function (value) {
        console.debug(value);
    };
    Logger.prototype._info = function (value) {
        console.info(value);
    };
    Logger.prototype._warn = function (value) {
        console.warn(value);
    };
    Logger.prototype._error = function (value) {
        console.error(value);
    };
    Logger.prototype._fatal = function (value) {
        console.error(value);
    };
    Logger.prototype._notify = function (value) {
        var length = this._when.length;
        for (var i = 0; i < length; i++) {
            this._when[i].notify(value);
        }
        length = this._once.length;
        for (var i = length - 1; i > -1; i--) {
            var result = this._once[i].notify(value);
            if (result) {
                this._once.splice(i, 1);
            }
        }
    };
    return Logger;
}());
exports.Logger = Logger;
var Subscriber = (function () {
    function Subscriber(check, handler) {
        this._handler = handler;
        if (typeof check === 'string') {
            this._check = function (value) {
                return value === check;
            };
        }
        else if (typeof check === 'function') {
            this._check = check;
        }
        else if (check instanceof Array) {
            this._check = function (value) {
                return check.indexOf(value) > -1;
            };
        }
        else if (check instanceof RegExp) {
            this._check = function (value) {
                return check.test(value);
            };
        }
        else
            throw "Unable to handle checks of type " + (typeof check);
    }
    Subscriber.prototype.notify = function (message) {
        if (this._check(message)) {
            this._handler(message);
            return true;
        }
        return false;
    };
    return Subscriber;
}());
var XHRTraceMessageState;
(function (XHRTraceMessageState) {
    XHRTraceMessageState[XHRTraceMessageState["Begin"] = 0] = "Begin";
    XHRTraceMessageState[XHRTraceMessageState["End"] = 1] = "End";
})(XHRTraceMessageState = exports.XHRTraceMessageState || (exports.XHRTraceMessageState = {}));
var XHRTraceMessage = (function () {
    function XHRTraceMessage() {
        this.state = XHRTraceMessageState.Begin;
    }
    return XHRTraceMessage;
}());
exports.XHRTraceMessage = XHRTraceMessage;
var XHRTraceMessageData = (function () {
    function XHRTraceMessageData() {
    }
    return XHRTraceMessageData;
}());
exports.XHRTraceMessageData = XHRTraceMessageData;



//////////////////
// WEBPACK FOOTER
// ./src/Logger/index.ts
// module id = 94
// module chunks = 0